'use strict';

var helper = require('../helper');

module.exports = {

    pushNewsletterStep1 (location, result) {
        if (!location) {
            return;
        }
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '14',
            'eventname': 'newsletter_start',
            'step': 'step1_' + result,
            'position': location
        };

        helper.log('Pushing newsletter submit step1 impression for \'' + location + '\'!', true);
        helper.push(pushObject);
    },

    pushNewsletterStep2 (result) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '15',
            'eventname': 'newsletter_step',
            'step': 'step2_' + result
        };

        helper.log('Pushing newsletter submit step2 impression!', true);
        helper.push(pushObject);
    },

    pushNewsletterStep3 (result) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '16',
            'eventname': 'newsletter_subscription',
            'step': 'step3_' + result
        };

        helper.log('Pushing newsletter submit step3 impression!', true);
        helper.push(pushObject);
    },

    pushNewsletterUnsubscribe () {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '141',
            'eventname': 'newsletter_unsubscribe'
        };

        helper.log('Pushing newsletter unsubsribe', true);
        helper.push(pushObject);
    },

    pushNewsletterError (errorStep, errorType) {
        let pushObject = {
            'event': 'GAevent',
            'eventID': '62',
            'eventname': 'frontend_error',
            'type': 'newsletter',
            'step': errorStep,
            'text': errorType
        };

        helper.push(pushObject);
    }

};
